import apiClient from 'api/apiClient';
import API_END_POINT from 'constants/apiEndPoints';
import { ApiResponse } from 'types';

interface CreateCopyProjectParams {
  ownerName: string;
  projectName: string;
  copyProjectName: string;
}

interface CreateCopyProjectResponse extends ApiResponse {
  ownerName: string;
  ownerEmail: string;
  projectId: string;
  projectName: string;
}

type CreateCopyProject = (params: CreateCopyProjectParams) => Promise<CreateCopyProjectResponse>;

const createCopyProject: CreateCopyProject = async ({ ownerName, projectName, copyProjectName }) => {
  const { data } = await apiClient.post(API_END_POINT.PROJECT.CREATE_COPY_PROJECT, {
    ownerName,
    projectName,
    copyProjectName,
    projectScope: 'Public',
  });

  return data;
};

export default createCopyProject;
